export default {
  back: "Вернуться ко всем субэкспонентам",
  access: "Доступ",
  deleteSubexp: "Удалить субэкспонента"
};
